<div class="table-wrapper table_wrapper_invoice">
    <div class="table_wrapper_invoice_header">
        <h4 i18n="@@dashboard.payment_history">Payment history</h4>
        <div class="d-flex align-items-center gap-2">
            <div class="custom_select">
                <div class="custom_select-header"
                    (click)="toggleDropdown($event)">
                    <div i18n="@@dashboard.download_as">Download as</div>
                    <div class="custom_select-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="#0A0A0A"
                                stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
                <ul class="custom_select-content" style="display: none;">
                    <li class="custom_select-item" (click)="downloadPDF()">
                        <svg  class="me-1" xmlns="http://www.w3.org/2000/svg" width="16"
                            height="17" viewBox="0 0 16 17" fill="none">
                            <path d="M6 7.8335V11.8335L7.33333 10.5002"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M5.99996 11.8333L4.66663 10.5"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M14.6667 7.16683V10.5002C14.6667 13.8335 13.3334 15.1668 10 15.1668H6.00004C2.66671 15.1668 1.33337 13.8335 1.33337 10.5002V6.50016C1.33337 3.16683 2.66671 1.8335 6.00004 1.8335H9.33337"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M14.6667 7.16683H12C10 7.16683 9.33337 6.50016 9.33337 4.50016V1.8335L14.6667 7.16683Z"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span i18n="@@dashboard.pdf">PDF</span>
                    </li>
                    <li class="custom_select-item" (click)="downloadExcel()">
                        <svg  class="me-1" xmlns="http://www.w3.org/2000/svg" width="16"
                            height="17" viewBox="0 0 16 17" fill="none">
                            <path d="M6 7.8335V11.8335L7.33333 10.5002"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M5.99996 11.8333L4.66663 10.5"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M14.6667 7.16683V10.5002C14.6667 13.8335 13.3334 15.1668 10 15.1668H6.00004C2.66671 15.1668 1.33337 13.8335 1.33337 10.5002V6.50016C1.33337 3.16683 2.66671 1.8335 6.00004 1.8335H9.33337"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M14.6667 7.16683H12C10 7.16683 9.33337 6.50016 9.33337 4.50016V1.8335L14.6667 7.16683Z"
                                stroke="#646464" stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span i18n="@@dashboard.xlsx">XLSX</span>
                    </li>
                </ul>
            </div>
            <a class="text-decoration-none text-reset" [routerLink]="'/payments'">
                <div class="secondary_grey_btn">
                    <span i18n="@@dashboard.view_all">View all</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M3.33337 10H16.6667M16.6667 10L11.6667 5M16.6667 10L11.6667 15" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </a>
        </div>
    </div>
    <div class="table_wrapper">

        <table class="marketing_table" id="paymentTable">
            <thead>
                <tr>
                    <th style="width: 1%">
                        <div class="custom-checkbox">
                            <input
                                class="select-item"
                                type="checkbox"
                                [checked]="selectAllPaymentHistory"
                                (change)="toggleAllSelections(paymentsHistory, 'selectAllPaymentHistory');selectAll($event)">
                            <svg *ngIf="!selectAllPaymentHistory"
                                class="unchecked"
                                xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="1" y="1" width="22" height="22" rx="3"
                                    stroke="#E0E0E0" stroke-width="2" />
                            </svg>
                            <svg *ngIf="selectAllPaymentHistory" class="checked"
                                width="20" height="20" viewBox="0 0 20 20"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="18" height="18" rx="3"
                                    fill="#1C6AB6" stroke="#1C6AB6"
                                    stroke-width="2" />
                                <path d="M16.6667 5L7.50004 14.1667L3.33337 10"
                                    stroke="white" stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </th>
                    <th i18n="@@dashboard.invoice">Invoice</th>
                    <th i18n="@@dashboard.client">Client</th>
                    <th i18n="@@dashboard.status">Status</th>
                    <th i18n="@@dashboard.date">Date</th>
                    <th i18n="@@dashboard.amount">Amount</th>
                    <!-- <th></th> -->
                </tr>
            </thead>
            <tbody>

                <tr
                    *ngFor="let paymentHistory of paymentsHistory; let i = index">
                    <td data-label>
                        <div class="custom-checkbox">
                            <input
                                class="select-item"
                                type="checkbox"
                                [checked]="paymentHistory.selected"
                                (change)="paymentHistory.selected = !paymentHistory.selected; toggleSelection(paymentsHistory, 'selectAllPaymentHistory');onCheckChange($event, paymentHistory.id)">
                            <svg *ngIf="!paymentHistory.selected"
                                class="unchecked"
                                xmlns="http://www.w3.org/2000/svg" width="24"
                                height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="1" y="1" width="22" height="22" rx="3"
                                    stroke="#E0E0E0" stroke-width="2" />
                            </svg>
                            <svg *ngIf="paymentHistory.selected" class="checked"
                                width="20" height="20" viewBox="0 0 20 20"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="18" height="18" rx="3"
                                    fill="#1C6AB6" stroke="#1C6AB6"
                                    stroke-width="2" />
                                <path d="M16.6667 5L7.50004 14.1667L3.33337 10"
                                    stroke="white" stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </td>
                    <td data-label="Invoice"><span>{{ paymentHistory.invoiceNum }}</span>
                        <!-- <div class="position-absolute d-none-block d-none"
                            style="top: 3px;right: 10px;">
                            <div
                                class="options-menu"
                                *ngIf="paymentHistory.menuVisible"
                                [ngClass]="{ upwards: isMenuUpwards }">

                                <button class="edit-option open_b2b_invoice">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M5.33325 4.66675H10.6666"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6 7.33325H10" stroke="#646464"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.edit">Edit</span>
                                </button>
                                <button class="edit-option">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6 7.33325V11.3333L7.33333 9.99992"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6.00008 11.3333L4.66675 10"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.pdf_download">PDF Download</span>

                                </button>
                                <button class="edit-option">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.send_share">Send/Share</span>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M5.93994 13.28L10.2866 8.9333C10.7999 8.41997 10.7999 7.57997 10.2866 7.06664L5.93994 2.71997"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="edit-option">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6.88672 11H9.10672"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6.33325 8.33325H9.66659"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.delete">Delete</span>
                                </button>
                            </div>
                            <div
                                class="dots_container-rounded w-100"
                                (click)="toggleMenu($event, paymentHistory, i)">
                                <svg class="dots-menu"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19" height="18" viewBox="0 0 19 18"
                                    fill="none">
                                    <path
                                        d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z"
                                        stroke="#393939" stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z"
                                        stroke="#393939" stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z"
                                        stroke="#393939" stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div> -->
                    </td>
                    <td data-label="Client"><span>{{ paymentHistory.client }}</span></td>
                    <td data-label="Status" class="status">
                        <div
                            class="order_status"
                            [ngClass]="{
                            'order_complete': paymentHistory.status === '',
                            'order_new': paymentHistory.status === 'Successful',
                            'order_preparing': paymentHistory.status === 'Pending',
                            'order_unpaid': paymentHistory.status === 'Unsuccessful'
                        }">

                            <svg xmlns="http://www.w3.org/2000/svg" width="8"
                                height="8" viewBox="0 0 8 8" fill="none">
                                <circle cx="4" cy="4" r="4" fill="#18F121" />
                            </svg>
                            {{ transStatus(paymentHistory.status) }}
                        </div>
                    </td>
                    <td data-label="Date"><span>{{ paymentHistory.date }}</span></td>
                    <td data-label="Amount" class="border-bottom-none-0"><span [innerHTML]="paymentHistory.amount"></span></td>
                    <!-- <td data-label class="d-none-none">
                         <div class="position-relative w-100">
                            <div
                                class="options-menu"
                                *ngIf="paymentHistory.menuVisible"
                                [ngClass]="{ upwards: isMenuUpwards }">

                                <button class="edit-option open_b2b_invoice">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M13.6666 7.53324V4.69326C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69326V12.1999C2.33325 13.9732 3.30659 14.3933 4.48659 13.1266L4.49325 13.1199C5.03991 12.5399 5.87324 12.5866 6.34658 13.2199L7.01992 14.1199"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M5.33325 4.66675H10.6666"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6 7.33325H10" stroke="#646464"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12.1408 9.84685L9.78077 12.2069C9.68743 12.3002 9.60075 12.4735 9.58075 12.6002L9.45409 13.5002C9.40742 13.8269 9.63409 14.0535 9.96076 14.0069L10.8608 13.8802C10.9874 13.8602 11.1674 13.7735 11.2541 13.6802L13.6141 11.3202C14.0208 10.9135 14.2141 10.4402 13.6141 9.8402C13.0208 9.24686 12.5474 9.44018 12.1408 9.84685Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M11.7996 10.1868C11.9996 10.9068 12.5596 11.4668 13.2796 11.6668"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.edit">Edit</span>
                                </button>
                                <button class="edit-option">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6 7.33325V11.3333L7.33333 9.99992"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6.00008 11.3333L4.66675 10"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99992 14.6666H5.99992C2.66659 14.6666 1.33325 13.3333 1.33325 9.99992V5.99992C1.33325 2.66659 2.66659 1.33325 5.99992 1.33325H9.33325"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M14.6666 6.66658H11.9999C9.99992 6.66658 9.33325 5.99992 9.33325 3.99992V1.33325L14.6666 6.66658Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.pdf_download">PDF Download</span>
                                </button>
                                <button class="edit-option">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M11.3066 4.11328C12.64 5.03995 13.56 6.51328 13.7466 8.21328"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M2.32666 8.24673C2.49999 6.5534 3.40666 5.08006 4.72666 4.14673"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M5.45996 13.96C6.23329 14.3533 7.11329 14.5733 8.03996 14.5733C8.93329 14.5733 9.77329 14.3733 10.5266 14.0066"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M8.0401 5.13342C9.06367 5.13342 9.89343 4.30366 9.89343 3.28009C9.89343 2.25652 9.06367 1.42676 8.0401 1.42676C7.01653 1.42676 6.18677 2.25652 6.18677 3.28009C6.18677 4.30366 7.01653 5.13342 8.0401 5.13342Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M3.22003 13.2799C4.2436 13.2799 5.07337 12.4501 5.07337 11.4266C5.07337 10.403 4.2436 9.57324 3.22003 9.57324C2.19646 9.57324 1.3667 10.403 1.3667 11.4266C1.3667 12.4501 2.19646 13.2799 3.22003 13.2799Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12.7801 13.2799C13.8037 13.2799 14.6334 12.4501 14.6334 11.4266C14.6334 10.403 13.8037 9.57324 12.7801 9.57324C11.7565 9.57324 10.9268 10.403 10.9268 11.4266C10.9268 12.4501 11.7565 13.2799 12.7801 13.2799Z"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.send_share">Send/Share</span>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M5.93994 13.28L10.2866 8.9333C10.7999 8.41997 10.7999 7.57997 10.2866 7.06664L5.93994 2.71997"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-miterlimit="10"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </button>
                                <button class="edit-option">
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        width="16" height="16"
                                        viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M14 3.98665C11.78 3.76665 9.54667 3.65332 7.32 3.65332C6 3.65332 4.68 3.71999 3.36 3.85332L2 3.98665"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M5.66675 3.31325L5.81341 2.43992C5.92008 1.80659 6.00008 1.33325 7.12675 1.33325H8.87341C10.0001 1.33325 10.0867 1.83325 10.1867 2.44659L10.3334 3.31325"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12.5667 6.09326L12.1334 12.8066C12.06 13.8533 12 14.6666 10.14 14.6666H5.86002C4.00002 14.6666 3.94002 13.8533 3.86668 12.8066L3.43335 6.09326"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6.88672 11H9.10672"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M6.33325 8.33325H9.66659"
                                            stroke="#646464" stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span i18n="@@dashboard.delete">Delete</span>
                                </button>
                            </div>
                            <div
                                class="dots_container-rounded w-100"
                                (click)="toggleMenu($event, paymentHistory, i)">
                                <svg class="dots-menu"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="19" height="18" viewBox="0 0 19 18"
                                    fill="none">
                                    <path
                                        d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z"
                                        stroke="#393939" stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z"
                                        stroke="#393939" stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z"
                                        stroke="#393939" stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div> 
                    </td> -->
                </tr>

            </tbody>
        </table>
    </div>

</div>